<template>
  <dashboard-template>
    <template slot="dashboard-header">
      <h6>{{ $t('projects.project_show_add_source') }}</h6>
    </template>
    <template slot="dashboard-body">
      <div class="dashboard-content">
        <ValidationObserver ref="observer" v-slot="{ invalid }">
          <contact-modal></contact-modal>
          <div class="source-edit-container d-flex mb-4">
            <div>
              <p>{{$t('sources.name_file')}}</p>
              <div class="d-flex">
                <validation-provider class="mb-4" rules="required" v-slot="{ errors }">
                  <input v-model="sourceFileName" class="form-control main-config-input" name="sourceFileName" type="text" :placeholder="$t('sources.name_label')">
                  <span class="validation-error-required pl-2" v-if="errors[0] === 'Pole jest wymagane'">{{ $t('validations.required') }}</span>
                </validation-provider>
                <img class="tooltip-icon icon-small align-self-start ml-3 mt-2" id="tooltip-source-name" v-bind:src="'/app/images/icons/info.svg'" />
                <b-popover target="tooltip-source-name" variant="warning" triggers="hover" placement="bottom">
                  <div v-html="$t('tooltips.source_name')"></div>
                </b-popover>
              </div>
              <div class="source-edit-container my-4 pb-4">
                <p>{{$t('sources.source_type')}}</p>
                <div class="d-flex">
                  <b-form-radio-group>
                    <b-form-radio id="primarySource" v-model="isSourcePrimary" :value="true">{{ $t('sources.main_file') }}</b-form-radio>
                    <b-form-radio id="additionalSource" v-model="isSourcePrimary" :value="false">{{ $t('sources.additional_file') }}</b-form-radio>
                  </b-form-radio-group>
                  <img class="tooltip-icon icon-small ml-3" id="tooltip-source-classification" v-bind:src="'/app/images/icons/info.svg'" />
                  <b-popover target="tooltip-source-classification" variant="warning" triggers="hover" placement="bottom">
                    <div v-html="$t('tooltips.source_classification')"></div>
                  </b-popover>
                </div>
              </div>
            </div>
            <div class="source-values">
              <p>{{$t('sources.data_type')}}</p>
              <div class="d-flex">
                <multiselect
                  @select="onSourceTypeSelect"
                  v-model="sourceType"
                  track-by="id"
                  label="name"
                  :placeholder="$t('global.select')"
                  :options="sourceTypes"
                  :searchable="false"
                  :multiple="false"
                  :selected-label="''"
                  :select-label="''"
                  :deselect-label="''"
                  :allow-empty="false">
                  <template slot="option" slot-scope="props">
                    <span class="option__title">{{ props.option.name }}</span>
                  </template>
                </multiselect>
                <img class="tooltip-icon icon-small ml-3" id="tooltip-source-type" v-bind:src="'/app/images/icons/info.svg'" />
                <b-popover target="tooltip-source-type" variant="warning" triggers="hover" placement="bottom">
                  <div v-html="$t('tooltips.source_type')"></div>
                </b-popover>
                <div class="ml-3">
                  <p class="mb-0">{{$t('global.no_format')}}</p>
                  <a href="#" @click="$bvModal.show('contactModal')"><u>{{$t('global.contact')}}</u></a>
                </div>
              </div>
              <div v-if="isXmlCustomSelected" class="mt-4 mb-3">
                <p>Położenie produktu w pliku:</p>
                <div class="d-flex">
                  <validation-provider class="w-100 mb-4" rules="required" v-slot="{ errors }">
                    <input v-model="xmlConfig" class="form-control" name="xmlCustomConfig" type="text" :placeholder="'Położenie produktu w pliku'">
                    <span class="validation-error-required pl-2" v-if="errors[0] === 'Pole jest wymagane'">{{ $t('validations.required') }}</span>
                  </validation-provider>
                </div>
              </div>
              <div v-if="isUrlVisible" class="mt-4 mb-3">
                <p>{{$t('sources.file_url')}}</p>
                <div class="d-flex">
                  <validation-provider class="w-100 mb-4" rules="required" v-slot="{ errors }">
                    <input v-model="sourceUrl" class="form-control url-config-input" name="sourceFileName" type="text" :placeholder="$t('global.link')">
                    <span class="validation-error-required pl-2" v-if="errors[0] === 'Pole jest wymagane'">{{ $t('validations.required') }}</span>
                  </validation-provider>
                  <img class="tooltip-icon icon-small align-self-start ml-3 mt-2" id="tooltip-source-url" v-bind:src="'/app/images/icons/info.svg'" />
                  <b-popover target="tooltip-source-url" variant="warning" triggers="hover" placement="bottom">
                    <div v-html="$t('tooltips.source_url')"></div>
                  </b-popover>
                </div>
              </div>
              <div v-else-if="isDocsSelected" class="mt-4">
                <div class="d-flex justify-content-between">
                  <p class="mb-1">{{ $t('sources.google_sheet_url') }}</p>
                  <p class="text-danger" v-show="!isGoogleSheetUrlValid">{{ $t('sources.invalid_google_sheet_url') }}</p>
                </div>
                <p class="text-gray-text"><small>{{ $t('global.for_example') }}: https://docs.google.com/spreadsheets/d/1BxiMVs0XRA5nFMdKvBdBZjgmUUqptlbs74OgvE2upms/edit#gid=0</small></p>
                <div class="mb-4">
                  <validation-provider rules="required" v-slot="{ errors }">
                    <input v-model="sheetUrl" class="form-control sheets-url-config-input" name="docsKey" type="text">
                    <span class="validation-error-required pl-2" v-if="errors[0] === 'Pole jest wymagane'">{{ $t('validations.required') }}</span>
                  </validation-provider>
                </div>
                <p class="mb-1">{{ $t('sources.worksheet_name') }}</p>
                <p class="text-gray-text"><small>{{ $t('sources.google_sheet_info') }}</small></p>
                <div>
                  <validation-provider class="mt-4" rules="required" v-slot="{ errors }">
                    <input v-model="docsConfig.worksheetName" class="form-control sheets-name-config-input" name="worksheetName" type="text">
                    <span class="validation-error-required pl-2" v-if="errors[0] === 'Pole jest wymagane'">{{ $t('validations.required') }}</span>
                  </validation-provider>
                  <div class="alert alert-warning d-flex align-items-center py-4 mt-4" role="alert">
                    <img width="40" height="40" src="/app/images/icons/warning.svg" class="mr-4" />
                    <div>
                      <p class="mb-0">{{ $t('sources.google_sheet_share') }}</p>
                      <p class="mb-0"><strong>docs-access@feeds-automated.iam.gserviceaccount.com</strong></p>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="isXmlSelected" class="alert alert-warning d-flex align-items-center mr-5 py-4" role="alert">
                <img width="40" height="40" src="/app/images/icons/warning.svg" class="mr-4" />
                <p class="mb-0">{{ $t('sources.xml_info')}}</p>
              </div>
            </div>
          </div>
          <div class="source-edit-container d-flex justify-content-between mt-4">
            <router-link :to="{ name: 'sources', params: { id: $route.params.projectId }}">
              <button class="btn btn-large btn-gray-dark">
                <arrow-left-circle-icon></arrow-left-circle-icon>
                <span>{{$t('sources.file_return')}}</span>
              </button>
            </router-link>
            <div v-if="!isSubmitted">
              <button class="btn btn-small btn-orange-dark" @click="submitSourceConfig" :disabled="invalid || !isSourceTypeSelected || !isSourcePrimarySelected || !isGoogleSheetUrlValid">
                <arrow-right-circle-icon></arrow-right-circle-icon>
                <span>{{$t('global.next')}}</span>
              </button>
            </div>
            <div v-else class="button-loading-spinner source-create-button-loading">
              <div class="spinner-border text-orange" role="status"></div>
            </div>
          </div>
        </ValidationObserver>
      </div>
    </template>
  </dashboard-template>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'
import DashboardTemplate from '@/views/Dashboard'
import Multiselect from 'vue-multiselect'
import { ArrowLeftCircleIcon, ArrowRightCircleIcon } from 'vue-feather-icons'
import ContactModal from './Partials/ContactModal'
import axios from 'axios'

extend('required', {
  ...required
})

export default {
  name: 'SourceCreate',

  data () {
    return {
      analyticsConfig: {},
      docsConfig: {
        docsKey: '',
        worksheetName: ''
      },
      ftpConfig: {},
      isAnalyticsSelected: false,
      isDocsSelected: false,
      isGoogleSheetUrlValid: true,
      isSourcePrimary: null,
      isSubmitted: false,
      isXmlSelected: false,
      isXmlCustomSelected: false,
      sheetUrl: '',
      sourceFileName: '',
      sourceType: null,
      sourceTypes: [
        { id: 1, name: 'XML', value: 'xml' },
        { id: 2, name: 'XML Ceneo', value: 'xml' },
        { id: 3, name: 'CSV', value: 'csv' },
        { id: 4, name: 'XLSX', value: 'excel' },
        { id: 5, name: 'Google Sheets', value: 'docs' },
        { id: 6, name: 'XML Custom', value: 'xml' }
      ],
      sourceUrl: '',
      xmlConfig: ''
    }
  },

  methods: {
    onSourceTypeSelect (value) {
      this.sourceType = value

      if (this.sourceType.value === 'docs') {
        this.isDocsSelected = true
      } else {
        this.isDocsSelected = false
        this.docsConfig = { docsKey: '', worksheetName: '' }
        this.sheetUrl = ''
      }

      if (this.sourceType.value === 'analytics') {
        this.isAnalyticsSelected = true
      } else {
        this.isAnalyticsSelected = false
      }

      if (this.sourceType.value === 'xml') {
        if (this.sourceType.name === 'XML Ceneo') {
          this.xmlConfig = 'offers.o'
          this.isXmlSelected = false
        } else if (this.sourceType.name === 'XML Custom') {
          this.isXmlSelected = false
          this.isXmlCustomSelected = true
        } else {
          this.xmlConfig = ''
          this.isXmlCustomSelected = false
          this.isXmlSelected = true
        }
      } else {
        this.isXmlSelected = false
        this.xmlConfig = ''
      }
    },

    submitSourceConfig () {
      this.isSubmitted = true

      const sourceConfig = {
        name: this.sourceFileName,
        active: true,
        description: '',
        config: {
          fileType: this.sourceType.value,
          primary: this.isSourcePrimary,
          url: this.sourceUrl,
          xmlConfig: this.xmlConfig
        }
      }

      if (this.isDocsSelected) sourceConfig.config.docsConfig = this.docsConfig
      if (this.isAnalyticsSelected) sourceConfig.config.analyticsConfig = {}

      axios.post(process.env.VUE_APP_API_ENDPOINT + '/data/sources/preview/' + this.$route.params.projectId, sourceConfig)
        .then((response) => {
          if ((response.status === 201) || (response.status === 200)) {
            let sourceData = {}
            if (response.data.products.length > 0) sourceData = response.data
            this.$router.push({ name: 'source.preview', params: { projectId: this.$route.params.projectId, sourceData: sourceData } })
          }
        })
        .catch((error) => {
          if (error.response) {
            this.isSubmitted = false
            if (this.sourceType.value === 'docs') {
              this.$bvToast.toast(this.$t('sources.google_sheet_error_description') + error.response.data.message, {
                autoHideDelay: 3000,
                solid: true,
                title: this.$t('sources.google_sheet_error'),
                variant: 'danger'
              })
            } else {
              if (error.response.data.code === 13) {
                this.$bvToast.toast(this.$t('sources.source_edit_error_read'), {
                  autoHideDelay: 3000,
                  solid: true,
                  title: this.$t('sources.source_add_error'),
                  variant: 'danger'
                })
              } else if ((error.response.data.code === 4) || (error.response.data.code === 5) || (error.response.data.code === 6)) {
                this.$bvToast.toast(this.$t('sources.source_edit_error_parsing'), {
                  autoHideDelay: 3000,
                  solid: true,
                  title: this.$t('sources.source_add_error'),
                  variant: 'danger'
                })
              } else if (error.response.data.code === 26) {
                this.$bvToast.toast(this.$t('sources.source_edit_error_name'), {
                  autoHideDelay: 3000,
                  solid: true,
                  title: this.$t('sources.source_add_error'),
                  variant: 'danger'
                })
              } else {
                this.$bvToast.toast(this.$t('global.error_occured') + error.response.data.message, {
                  autoHideDelay: 3000,
                  solid: true,
                  title: this.$t('sources.source_add_error'),
                  variant: 'danger'
                })
              }
            }
          }
        })
    }
  },

  computed: {
    isSourceTypeSelected () {
      if (this.sourceType !== null) return true
      else return false
    },

    isSourcePrimarySelected () {
      if (this.isSourcePrimary !== null) return true
      else return false
    },

    isUrlVisible () {
      if (this.sourceType === null) return true
      else if ((this.sourceType.value !== 'analytics') && (this.sourceType.value !== 'docs')) return true
      else return false
    }
  },

  watch: {
    sheetUrl (newValue) {
      try {
        const matches = new RegExp('/spreadsheets/d/([a-zA-Z0-9-_]+)').exec(newValue)
        if (matches[1] !== null) this.docsConfig.docsKey = matches[1]
        this.isGoogleSheetUrlValid = true
      } catch (e) {
        this.isGoogleSheetUrlValid = false
      }
    }
  },

  components: { ArrowLeftCircleIcon, ArrowRightCircleIcon, ContactModal, DashboardTemplate, Multiselect, ValidationObserver, ValidationProvider }
}
</script>
